import {atom} from 'jotai'
import { JobCard } from "@/interfaces/api/models";

const dataAtom = atom({});
export const readWriteAtom = atom(
    (get: any) => get(dataAtom),
    (get: any, set: any, id: string, newVal: any) => {
        const data = get(dataAtom);
        const updatedData = { ...data, [id]: newVal };
        set(dataAtom, updatedData)
    }
)


// Global password-change prompt state (triggered post-login if weak)
export const passwordChangePromptAtom = atom<{ open: boolean; title?: string; message?: string; }>({
    open: false,
    title: undefined,
    message: undefined
})

const filterStatesAtom = atom({})
export const readWriteFilterStatesAtom = atom(
    (get: any) => get(filterStatesAtom),
    (get: any, set: any, filterName: string, newVal: any) => {
        const data = get(filterStatesAtom);
        const updatedData = { ...data, [filterName]: newVal };
        set(filterStatesAtom, updatedData)
    }
)

export const openModalsAtom = atom<string[]>([])

export const inventoryDrawerAtom = atom<{
    selectedInventory: any | null;
}>({
    selectedInventory: null
})

export const savedInventoryAtom = atom<any | null>(null)

// Atom for tracking job drag operations
export const jobDragStateAtom = atom<{
    isDragging: boolean;
    job: JobCard | null;
}>({
    isDragging: false,
    job: null
})

export const justCompletedSetupAtom = atom<boolean>(false)

export const forceInitialSetupAtom = atom<boolean>(false)
